import React from "react";

const MarketingAgents = () => {
  return <div>MarketingAgents</div>;
};

export default MarketingAgents;
